import { Directive, HostBinding, HostListener } from '@angular/core';
import { DndEvent } from './dnd-utils';
import { DndDraggableDirective } from './dnd-draggable.directive';
export class DndHandleDirective {

  
  draggable = true;
/**
 * @param {?} parent
 */
constructor( parent:DndDraggableDirective ) {

    parent.registerDragHandle( this );
  }
/**
 * @param {?} event
 * @return {?}
 */
onDragEvent( event:DndEvent ) {

    event._dndUsingHandle = true;
  }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: "[dndHandle]"
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: DndDraggableDirective, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'draggable': [{ type: HostBinding, args: ["attr.draggable", ] },],
'onDragEvent': [{ type: HostListener, args: ["dragstart", [ "$event" ], ] },{ type: HostListener, args: ["dragend", [ "$event" ], ] },],
};
}

function DndHandleDirective_tsickle_Closure_declarations() {
/** @type {?} */
DndHandleDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
DndHandleDirective.ctorParameters;
/** @type {?} */
DndHandleDirective.propDecorators;
/** @type {?} */
DndHandleDirective.prototype.draggable;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
